import { Button } from "@mui/material";
import styles from "./SpecialPrimaryButtons.module.css";

// const SpecialPrimaryButtons = () => {
//   return (
//     <div className={styles.specialPrimaryButtons}>
//       <div className={styles.specialPrimaryButtons1}>
//         <Button
//           className={styles.buttonPrimary}
//           disableElevation={true}
//           variant="contained"
//           sx={{
//             textTransform: "none",
//             color: "#fff",
//             fontSize: "14",
//             background: "#46619d",
//             borderRadius: "8px",
//             "&:hover": { background: "#46619d" },
//             width: 78,
//             height: 36,
//           }}
//         >
//           Create
//         </Button>
//       </div>
//     </div>
//   );
// };

const SpecialPrimaryButtons = (props) => {
  return (
    <div className={styles.specialPrimaryButtons}>
      <div className={styles.specialPrimaryButtons1}>
        <Button
          className={styles.buttonPrimary}
          disableElevation={true}
          variant="contained"
          sx={{
            textTransform: "none",
            color: "#fff",
            fontSize: "14",
            background: "#46619d",
            borderRadius: "8px",
            "&:hover": { background: "#46619d" },
            // width: 78,
            height: 36,
          }}
          onClick={props.onClick} // Add the onClick prop here
        >
          {props.label}
        </Button>
      </div>
    </div>
  );
};

export default SpecialPrimaryButtons;
